<template>
  <div id="cv-container">
    <div class="presentation">
      <h3 class="block-title">PRÉSENTATION</h3>
      <div class="top-container">
        <div><img class="profile-picture" src="/img/alexandre.jpg" alt="Photo Alexandre Meux" /></div>
        <div class="intro-btn">
          <h3>PORTFOLIO</h3>
          <h2>Alexandre Meux</h2>
          <p class="introduction">
            Je m'appelle Alexandre Meux, étudiant en deuxième année de BUT Métiers du Multimédia et de l'Internet, parcours Création Numérique.
            Grâce à ma formation, j’ai pu acquérir un large éventail de compétences dans des domaines variés, faisant de moi un profil polyvalent.
            Je maîtrise notamment le développement web, l’audiovisuel, la gestion de projet, le design graphique, l’ergonomie et l’accessibilité, ainsi que la communication digitale.
            Bien que je m’intéresse à l’ensemble de ces domaines, mes domaines de prédilection restent le développement web et le graphisme.
            Je souhaite aujourd’hui mettre en pratique ces compétences dans un cadre professionnel, en travaillant dans un stage orienté création numérique pour ma troisième année de BUT.
          </p>
          <RouterLink to="/portfolio/tous"><button class="cta-button">Voir mes projets</button></RouterLink>
        </div>
      </div>
    </div>

    <hr>

    <div id="cv-sections">
      <!-- <div class="shape-container">
        <img class="shape" alt="shape" src="/img/shape.png" />
      </div> -->
      <h3 class="block-title">CURRICULUM VITAE</h3>

      <div class="cv-details">

        <section id="experiences-section" class="cv-section">
          <div class="section-title">
            <img class="pictogrammes" src="/img/pictogramme/experiences.png" alt="Icône expériences" />
            <h3>Expériences</h3>
          </div>
          <ul class="list experience-list">

            <li class="item">
              <h4>2025 : Stage graphiste de 40 jours | CyberSpector (Champs-Sur-Marne)</h4>
              <ul>
                <li>Création de contenus visuels et vidéos pédagogiques/marketing sur Photoshop, Canva, Synthesia ou ElevenLabs.</li>
                <li>Conception de modules e-learning sur la cybersécurité avec iSpring et rédaction de scripts.</li>
                <li>Réalisation de présentations commerciales et institutionnelles.</li>
                <li>Création de templates personnalisés sur Canva.</li>
              </ul>
            </li>

            <li class="item">
              <h4>2020 : Stage de 3ème | Pharmacie SINE-NDEFEU (Malakoff)</h4>
              <ul>
                <li>Trier et classer les produits</li>
                <li>Débaler et stocker les livraisons</li>
                <li>Rédiger un rapport de stage</li>
              </ul>
            </li>
          </ul>
        </section>


        <section id="formations-section" class="cv-section">
          <div class="section-title">
            <img class="pictogrammes" src="/img/pictogramme/formation.png" alt="Icône formation" />
            <h3>Formations</h3>
          </div>
          <ul class="list formation-list">
            <li class="item">
              <h4>BUT Métiers du Multimédia et de l'Internet</h4>
              <ul>
                <li>2023 - En cours</li>
                <li>IUT Sénart Fontainebleau (UPEC)</li>
                <li>Parcours création numérique</li>
              </ul>
            </li>
            <li class="item">
              <h4>Baccalauréat</h4>
              <ul>
                <li>2023</li>
                <li>Baccalauréat Général</li>
                <li>Spécialité LLCE et SES</li>
              </ul>
            </li>
          </ul>
        </section>


        <section id="interests-section" class="cv-section">
          <div class="section-title">
            <img class="pictogrammes" src="/img/pictogramme/centresInteret.png" alt="Icône centres d'intérêts" />
            <h3>Centres d'intérêts</h3>
          </div>
          <ul class="list interest-list">
            <li class="item">
              <h4><img class="element-img" src="/img/pictogramme/jeux.png" alt="Icône jeux-vidéos">Jeux-vidéos</h4>
              <ul>
                <li></li>
              </ul>
            </li>
            <li class="item">
              <h4><img class="element-img" src="/img/pictogramme/football.png" alt="Icône football">Football</h4>
              <ul>
                <li></li>
              </ul>
            </li>
            <li class="item">
              <h4><img class="element-img" src="/img/pictogramme/programmation.png" alt="Icône programmation">Programmation</h4>
              <ul>
                <li></li>
              </ul>
            </li>
          </ul>
        </section>


        <section id="skills-section" class="cv-section">
          <div class="section-title">
            <img class="pictogrammes" src="/img/pictogramme/divers.png" alt="Icône soft skills" />
            <h3>Soft Skills</h3>
          </div>
          <ul class="list skills-list">
            <li class="item">
              <h4>Calme</h4>
              <ul>
                <li></li>
              </ul>
            </li>
            <li class="item">
              <h4>Polyvalence</h4>
              <ul>
                <li></li>
              </ul>
            </li>
            <li class="item">
              <h4>Rigueur</h4>
              <ul>
                <li></li>
              </ul>
            </li>
          </ul>
        </section>


        <section id="reference-section" class="cv-section">
          <div class="section-title">
            <img class="pictogrammes" src="/img/pictogramme/reference.png" alt="Icône référence" />
            <h3>Référence</h3>
          </div>
          <ul class="list skills-list">
            <li class="item">
              <h4>Ramanou BIAOU (Ancien tuteur de stage)</h4>
              <ul>
                <li class="element"><img class="invert element-img" src="/img/pictogramme/entreprise.png" alt="Icône entreprise">
                  <div class="underline">Entreprise:</div>CyberSpector<img class="element-img" src="/img/pictogramme/CyberSpector.png" alt="Logo CyberSpector">
                </li>
                <li class="element"><img class="invert element-img" src="/img/pictogramme/poste.png" alt="Icône poste">
                  <div class="underline">Poste:</div>CEO
                </li>
                <li class="element"><img class="invert element-img" src="/img/pictogramme/email.svg" alt="Icône email">
                  <div class="underline">Mail:</div>ramanou@cyberspector.com
                </li>
                <li class="element"><img class="invert element-img" src="/img/pictogramme/phone.png" alt="Icône téléphone">
                  <div class="underline">Téléphone:</div>06 05 50 76 83
                </li>
              </ul>
            </li>
          </ul>
        </section>


        <!-- SECTION HARD SKILLS (Single Slide Carousel) -->
        <section id="hard-skills-section" class="cv-section full-width-section">
          <div class="section-title">
            <img class="pictogrammes" src="/img/pictogramme/hard-skills.png" alt="Icône hard skills" />
            <h3>Hard Skills</h3>
          </div>

          <div class="carousel-wrapper">
            <!-- Bouton Gauche -->
            <div class="nav-btn prev-btn" @click="scrollCarousel('left')" aria-label="Précédent">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </div>

            <!-- Liste (référence 'skillsContainer') -->
            <ul class="list skills-list hard-skills" ref="skillsContainer">
              <!-- Design graphique & UI/UX -->
              <li class="skill-item"><img src="/img/pictogramme/competences/illustrator.png" alt="Logo Illustrator">
                <p>Illustrator</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/photoshop.png" alt="Logo Photoshop">
                <p>Photoshop</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/indesign.png" alt="Logo InDesign">
                <p>InDesign</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/animate.png" alt="Logo Animate">
                <p>Animate</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/aftereffects.png" alt="Logo After Effects">
                <p>After Effects</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/premierepro.png" alt="Logo Premiere Pro">
                <p>Premiere Pro</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/audition.png" alt="Logo Audition">
                <p>Audition</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/audacity.png" alt="Logo Audacity">
                <p>Audacity</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/figma.png" alt="Logo Figma">
                <p>Figma</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/canva.png" alt="Logo Canva">
                <p>Canva</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/axure.png" alt="Logo Axure">
                <p>Axure</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/flutterflow.png" alt="Logo FlutterFlow">
                <p>FlutterFlow</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/sphere.png" alt="Logo Sphere">
                <p>Sphere</p>
              </li>

              <!-- Développement web & logiciel -->
              <li class="skill-item"><img src="/img/pictogramme/competences/html.svg" alt="Logo HTML">
                <p>HTML</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/css.svg" alt="Logo CSS">
                <p>CSS</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/js.svg" alt="Logo JavaScript">
                <p>JavaScript</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/vuejs.ico" alt="Logo Vue.js">
                <p>Vue.js</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/php.png" alt="Logo PHP">
                <p>PHP</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/vscode.png" alt="Logo VS Code">
                <p>VS Code</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/docker.png" alt="Logo Docker">
                <p>Docker</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/wamp.png" alt="Logo Wamp">
                <p>Wamp</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/githubDesktop.png" alt="Logo GitHub Desktop">
                <p>GitHub Desktop</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/wordpress.png" alt="Logo WordPress">
                <p>WordPress</p>
              </li>

              <!-- Animation / 3D / Simulation -->
              <li class="skill-item"><img src="/img/pictogramme/competences/maya.webp" alt="Logo Maya">
                <p>Maya</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/iSpring.png" alt="Logo iSpring">
                <p>iSpring</p>
              </li>

              <!-- Bureautique -->
              <li class="skill-item"><img src="/img/pictogramme/competences/excel.png" alt="Logo Excel">
                <p>Excel</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/word.png" alt="Logo Word">
                <p>Word</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/powerpoint.png" alt="Logo PowerPoint">
                <p>PowerPoint</p>
              </li>
              <li class="skill-item"><img src="/img/pictogramme/competences/gdoc.png" alt="Logo Google Docs">
                <p>Google Docs</p>
              </li>

              <!-- Réseau & transfert de fichiers -->
              <li class="skill-item"><img src="/img/pictogramme/competences/filezilla.png" alt="Logo FileZilla">
                <p>FileZilla</p>
              </li>
            </ul>

            <!-- Bouton Droite -->
            <div class="nav-btn next-btn" @click="scrollCarousel('right')" aria-label="Suivant">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </div>
        </section>

      </div>
    </div>


    <hr>

    <div>

      <div class="section-alternance">
        <div class="alternance">
          <h3 class="block-title">STAGE</h3>
          <p>
            Dans le cadre de ma deuxième année de BUT Métiers du Multimédia et de l’Internet,
            parcours Création Numérique à l’IUT de Sénart-Fontainebleau (UPEC), je suis
            à la recherche d’un stage à partir de février 2026 pour ma troisième année.
            <br><br>
            Je souhaite intégrer une structure dynamique dans les domaines du développement web, du design graphique,
            de la communication digitale,
            de l’audiovisuel ou tout autre secteur lié à la création numérique.
            Mon objectif est de mettre en pratique les compétences acquises au cours de ma formation,
            tout en développant mes compétences et ma créativité au sein d’un environnement professionnel enrichissant.
            <br><br>
            Sérieux, curieux et polyvalent, je suis prêt à m’investir pleinement dans les
            missions qui pourraient m'être confiées.
            Le stage représente pour moi une opportunité concrète de développer
            mon expérience professionnelle tout en poursuivant ma formation en BUT MMI.
          </p>
        </div>



        <div class="alternance-details">
          <h3 class="block-title">Informations pratiques</h3>
          <ul class="info-list">
            <li><span class="label">Date de début</span>16 FÉVRIER 2026</li>
            <li><span class="label">Durée</span>60 à 80 jours travaillés</li>
            <li><span class="label">Rythme</span>3 jours en entreprise / 2 jours à l’IUT</li>
            <li><span class="label">Type de contrat</span>STAGE</li>
            <li><span class="label">Localisation</span> PARIS ET BANLIEUE</li>
            <li><span class="label">Domaines recherchés</span> DÉVELOPPEMENT WEB, GRAPHISME, AUDIOVISUEL, UI/UX DESIGN, COMMUNICATION DIGITALE</li>
          </ul>
        </div>
      </div>


      <hr>

      <div class="section-contact">
        <div class="card">
          <h3 class="block-title">Contact</h3>
          <div class="info-item">
            <img class="invert" src="/img/pictogramme/email.svg" alt="Icône email">
            <div>
              <div class="info-label">Email</div>
              <div class="info-value"><a target="_blank" href="mailto:alexandre.meux@etu.u-pec.fr">alexandre.meux@etu.u-pec.fr</a></div>
            </div>
          </div>
          <div class="info-item">
            <img class="invert" src="/img/pictogramme/phone.png" alt="Icône téléphone">
            <div>
              <div class="info-label">Téléphone</div>
              <div class="info-value"><a target="_blank" href="tel:0781150636">07 50 57 84 84</a></div>
            </div>
          </div>
          <div class="info-item">
            <img class="invert" src="/img/pictogramme/linkedIn.png" alt="Icône LinkedIn">
            <div>
              <div class="info-label">LinkedIn</div>
              <div class="info-value"><a target="_blank" href="https://www.linkedin.com/in/alexandre-meux-2ba28a29b/">https://www.linkedin.com/in/alexandre-meux-2ba28a29b/</a></div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "APropos",
  methods: {
    scrollCarousel(direction) {
      const container = this.$refs.skillsContainer;
      
      if (container) {
        // La distance de défilement est égale à la largeur visible du conteneur
        // pour faire défiler exactement un élément (100% width)
        const scrollAmount = container.clientWidth;
        
        if (direction === 'left') {
          container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
          container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }
    }
  }
}
</script>


<style scoped>
main {
  margin: 8rem 0;
}

#cv-container {
  padding: 0 5vw;
}

.presentation {
  margin-top: 6rem;
}

.top-container {
  display: flex;
  text-align: left;
  flex-wrap: nowrap;
  gap: 8rem;
  margin-bottom: 5rem;
}

.intro-btn {
  display: flex;
  flex-direction: column;
  background: var(--hard-blue);
  box-shadow: var(--box-shadow-1);
  padding: 4rem;
  gap: 1.25rem;
  text-align: justify;
}

.cta-button {
  margin-top: 2rem;
}

.underline {
  text-decoration: underline;
  font-weight: 600;
  margin-right: 4px;
}

hr {
  margin: 10rem 0;
}

.top-container .profile-picture {
  border-radius: 20px;
  width: 40rem;
  padding: 8px;
  border: var(--light-gray-border);
  box-shadow: var(--box-shadow-1);
}

.introduction {
  line-height: 1.5;
  max-width: 800px;
  border-top: 1px solid var(--gray-hover-1);
  padding-top: 2rem;
}

.cv {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem;
  margin: 4rem 0;
}

.shape-container .shape {
  width: 25vw;
  margin: 0 auto;
  display: block;
}

.cv-details {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  margin-bottom: 6rem;
  gap: 2vw;
}

.block-title {
  font-size: 3.5rem;
  font-weight: 900;
  margin-bottom: 2rem;
}

.cv-section {
  background: var(--hard-blue);
  border-radius: 0;
  box-shadow: var(--box-shadow-1);
  padding: 2rem;
  overflow: hidden; 
}

.cv-section,
.cv-section h4,
.cv-section li,
.cv-section h3 {
  transition: all 0.25s ease-in;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.element {
  margin: 10px 0;
}

.section-title img.pictogrammes {
  width: 4.5rem;
  height: auto;
}

.list {
  margin-left: 20px;
}

.element-img {
  width: 2.5rem;
  margin: 0 8px;
  transition: all 0.25s ease-in;
}

ul li {
  font-size: 1.33rem;
  font-weight: 400;
  margin: 0.25rem 0;
}

ul li li {
  display: flex;
  align-items: center;
}

.item {
  list-style-type: disc;
}

.experience-list ul li,
.formation-list ul li {
  list-style-type: none;
  position: relative;
  padding-left: 1.25rem;
  margin: 5px 0;
  font-size: 13px;
}

.experience-list ul li::before,
.formation-list ul li::before {
  content: "–";
  position: absolute;
  font-size: 9px;
  font-weight: 500;
  left: -0.85rem;
  color: #ffffff;
}

ul li h4 {
  margin: 0.5rem 0;
}

.section-alternance {
  display: grid;
  grid-template-columns: 2fr 3fr;
  align-items: start;
  gap: 2rem;
  margin-bottom: 6rem;
  background: var(--hard-blue);
  padding: 4vw;
  box-shadow: var(--box-shadow-1);
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-list li {
  padding: 12px 0;
  line-height: 1.5;
  font-size: 2.15vw;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: -1px;
}

.info-list li:not(.info-list li:last-child) {
  border-bottom: 1px solid var(--gray-hover-1);
}

.label {
  font-weight: bold;
  text-transform: none;
  display: block;
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: 700;
  color: var(--yellow-white);
  letter-spacing: 0;
}

.alternance-details {
  border-left: 1px solid var(--gray-hover-1);
  padding-left: 3rem;
}

.section-contact {
  display: flex;
  gap: 4rem;
  margin-bottom: 6rem;
}

.introduction,
.section-alternance p {
  line-height: 1.75;
}

.card {
  background-color: var(--hard-blue);
  padding: 2rem;
  border-radius: 0;
  width: 100%;
  box-shadow: var(--box-shadow-1);
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--gray-hover-1);
  padding-bottom: 1rem;
}

.info-item img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  margin-right: 1.5rem;
}

.info-label {
  color: var(--gray);
  font-size: 14px;
  font-weight: 700;
}

.info-value {
  font-weight: bold;
  margin-top: 0.2rem;
  font-size: 12px;
}

/* --- STYLES CARROUSEL --- */

.carousel-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;
  max-width: 600px; /* Limite la largeur pour l'esthétique du mode 1-item */
  margin: 0 auto;   /* Centre le carrousel dans la section */
}

/* Boutons de navigation */
.nav-btn {
  background: transparent;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  box-shadow: var(--box-shadow-1);
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.3s ease;
  z-index: 2;
}

.nav-btn:hover {
  background: var(--gray-hover-1);
}

.hard-skills {
  display: flex;
  flex-wrap: nowrap;
  gap: 0; /* Pas d'espace pour garantir le calage à 100% */
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory; /* Force le calage sur chaque élément */
  padding: 10px 0;
  margin-left: 0;
  width: 100%; /* Prend toute la place dispo entre les flèches */
  
  /* Cache la scrollbar */
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.hard-skills::-webkit-scrollbar {
  display: none;
}

.hard-skills img {
  width: 10vw;
  object-fit: contain;
}

.hard-skills li p {
  font-weight: 700;
  font-size: 1.3rem; /* Agrandit le texte */
  margin-top: 5px;
  text-align: center;
  white-space: nowrap;
}

.skill-item {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 100%; /* Chaque item prend 100% de la largeur du conteneur parent */
  flex: 0 0 100%;  /* Empêche le rétrécissement flex */
  scroll-snap-align: center; /* L'élément se cale au centre lors du scroll */
  padding: 10px;
}

/* --- MEDIA QUERIES --- */

@media (max-width: 820px) {
  .top-container {
    flex-wrap: wrap-reverse;
  }
  .profile-picture {
    width: 65vw;
  }
}

@media (max-width: 990px) {
  .cv-details {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(6, 1fr);
  }
  
}

@media (max-width: 650px) {
  .cv-details {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
  
  /* On garde les boutons même sur mobile pour ce mode "diapositive", 
     mais on peut les masquer si l'utilisateur préfère le swipe uniquement.
     Pour l'instant, je les laisse pour la clarté de la navigation. */
}

@media (max-width: 830px) {
  .section-alternance {
    grid-template-columns: 1fr;
  }
  .alternance-details {
    border-left: none;
    padding-left: 0;
    padding-top: 2rem;
    border-top: 1px solid var(--gray-hover-1);
  }
  .info-list li {
    font-size: 3.5vw;
  }
}
</style>